import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const MobileNotchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 10 14" fill="none" {...props}>
      <path
        d="M6.75 1.3125V1.75C6.75 1.99063 6.55312 2.1875 6.3125 2.1875H3.6875C3.44688 2.1875 3.25 1.99063 3.25 1.75V1.3125H2.375C1.89102 1.3125 1.5 1.70352 1.5 2.1875V11.8125C1.5 12.2965 1.89102 12.6875 2.375 12.6875H7.625C8.10898 12.6875 8.5 12.2965 8.5 11.8125V2.1875C8.5 1.70352 8.10898 1.3125 7.625 1.3125H6.75ZM0.1875 2.1875C0.1875 0.978906 1.16641 0 2.375 0H7.625C8.83359 0 9.8125 0.978906 9.8125 2.1875V11.8125C9.8125 13.0211 8.83359 14 7.625 14H2.375C1.16641 14 0.1875 13.0211 0.1875 11.8125V2.1875Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
